import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingCart, Package } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { getCartItemsCount } = useCart();

  const navigation = [
    { name: 'Főoldal', path: '/' },
    { name: 'Étlap', path: '/menu' },
    { name: 'Galéria', path: '/gallery' },
    { name: 'Vélemények', path: '/reviews' },
    { name: 'Rólunk', path: '/about' },
    { name: 'Kapcsolat', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="text-3xl font-black text-gray-900">
              <span className="text-[#00BCD4]">Boldog</span>
              <span className="text-[#FFA726]"> Büfé</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-semibold transition-colors ${
                  isActive(item.path)
                    ? 'text-[#00BCD4]'
                    : 'text-gray-700 hover:text-[#00BCD4]'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Right Side Actions */}
          <div className="flex items-center space-x-4">
            {/* Rendeléseim (My Orders) Button - Desktop */}
            <Link
              to="/order-tracking"
              className="hidden md:flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-[#00BCD4] to-[#00ACC1] text-white rounded-lg font-semibold hover:shadow-lg transition-all"
            >
              <Package className="w-5 h-5" />
              <span>Rendeléseim</span>
            </Link>

            {/* Cart Button */}
            <Link
              to="/cart"
              className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <ShoppingCart className="w-6 h-6 text-gray-700" />
              {getCartItemsCount() > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#00BCD4] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {getCartItemsCount()}
                </span>
              )}
            </Link>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6 text-gray-700" />
              ) : (
                <Menu className="w-6 h-6 text-gray-700" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-2">
            {/* Rendeléseim Button - Mobile */}
            <Link
              to="/order-tracking"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center space-x-3 px-4 py-3 rounded-lg font-semibold bg-gradient-to-r from-[#00BCD4] to-[#00ACC1] text-white"
            >
              <Package className="w-5 h-5" />
              <span>📦 Rendeléseim</span>
            </Link>

            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg font-semibold transition-colors ${
                  isActive(item.path)
                    ? 'bg-[#00BCD4] text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
